export default __webpack_public_path__ + "static/media/warning--dual-lanes-left-turn--g1.a0868b18.png";